import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Home from '../../../components/pages/user/Home';


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
  }, dispatch);
}



function mapStateToProps(state) {
  const {session, io} = state;

  return {
    session,
    io
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/pages/user/Home.js